import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import TokenRevealText from './TokenRevealText';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        {/* Brand Column */}
        <div className="footer-brand">
          <Link to="/">
            <img src="/logo.png" alt="C2P Engineering Solutions" className="footer-logo-img" />
          </Link>
          <p className="footer-tagline">
            End-to-End Engineering &amp; Manufacturing Solutions since 2003. From concept to production &mdash; we deliver.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4><TokenRevealText text="Quick Links" speed="medium" /></h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/solutions">Solutions</Link></li>
            <li><Link to="/infrastructure">Infrastructure</Link></li>
            <li><Link to="/clients">Clients</Link></li>
            <li><Link to="/quality">Quality</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Infrastructure */}
        <div className="footer-col">
          <h4><TokenRevealText text="Infrastructure" speed="medium" /></h4>
          <ul>
            <li><Link to="/infrastructure#facility">Manufacturing Facility</Link></li>
            <li><Link to="/infrastructure#toolroom">Tool Room</Link></li>
            <li><Link to="/infrastructure#machines">Injection Molding Machines</Link></li>
          </ul>
        </div>

        {/* Products */}
        <div className="footer-col">
          <h4><TokenRevealText text="Solutions" speed="medium" /></h4>
          <ul>
            <li><Link to="/solutions#enclosures">Industrial Enclosures</Link></li>
            <li><Link to="/solutions#tooling">Molds &amp; Dies</Link></li>
            <li><Link to="/solutions#thermal">Heat Sink Profiles</Link></li>
            <li><Link to="/solutions#connectivity">Connectivity &amp; Cables</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4><TokenRevealText text="Services" speed="medium" /></h4>
          <ul>
            <li><Link to="/services#product-engineering">Product Engineering</Link></li>
            <li><Link to="/services#mechanical-design">Mechanical Design</Link></li>
            <li><Link to="/services#tooling-mold">Tooling &amp; Mold</Link></li>
            <li><Link to="/services#manufacturing">Manufacturing</Link></li>
            <li><Link to="/services#analogics-c2p">Analogics + C2P</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4><TokenRevealText text="Contact" speed="medium" /></h4>
          <div className="footer-contact-item">
            <span className="footer-contact-label">Address:</span>
            <span>
              Survey No. 23/2, <span className="nowrap">Part-A</span>,
              <span className="nowrap">Gundala Pochampally</span>, Medchal, Hyderabad &ndash; 500014, Telangana
            </span>
          </div>
          <div className="footer-contact-item">
            <span className="footer-contact-label">Phone:</span>
            <span>+91 9000103522 / 9704403522</span>
          </div>
          <div className="footer-contact-item">
            <span className="footer-contact-label">Email:</span>
            <a href="mailto:info@c2psolutions.com">info@c2psolutions.com</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>&copy; {new Date().getFullYear()} C2P Engineering Solutions Pvt. Ltd. All rights reserved.</p>
          <p>A group company of Analogics Tech India Ltd.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;